import { forwardRef, memo } from "react";

export const SuitcaseIcon = memo(
  forwardRef(function SuitcaseIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.43431 14.5574C9.04363 14.5574 8.72656 14.2403 8.72656 13.8496V11.4555C8.72656 11.0649 9.04363 10.7478 9.43431 10.7478C9.82499 10.7478 10.1421 11.0649 10.1421 11.4555V13.8496C10.1421 14.2403 9.82499 14.5574 9.43431 14.5574"
          fill={color}
        />
        <mask
          id="mask0_15054_24184"
          maskUnits="userSpaceOnUse"
          x="0"
          y="2"
          width={size}
          height={size}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 2.43445H18.8636V12.1645H0V2.43445Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_15054_24184)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.41549 8.86362C3.65763 10.0819 6.48485 10.7491 9.42718 10.7491C12.3752 10.7491 15.2052 10.0819 17.4483 8.86362V6.03074C17.4483 4.82758 16.4754 3.84994 15.2779 3.84994H3.59535C2.39313 3.84994 1.41549 4.8238 1.41549 6.02131V8.86362ZM9.42718 12.1645C6.0819 12.1645 2.85741 11.3549 0.350099 9.88655C0.133056 9.7601 0 9.52796 0 9.276V6.02131C0 4.04339 1.61272 2.43445 3.59535 2.43445H15.2779C17.2558 2.43445 18.8638 4.04717 18.8638 6.03074V9.276C18.8638 9.52796 18.7298 9.7601 18.5137 9.88655C16.0064 11.3549 12.7791 12.1645 9.42718 12.1645V12.1645Z"
            fill={color}
          />
        </g>
        <mask
          id="mask1_15054_24184"
          maskUnits="userSpaceOnUse"
          x="5"
          y="0"
          width="9"
          height="4"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.42188 0H13.443V3.84627H5.42188V0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_15054_24184)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7353 3.84624C12.3446 3.84624 12.0275 3.52917 12.0275 3.1385V2.79312C12.0275 2.03347 11.4094 1.41537 10.6498 1.41537H8.21511C7.45547 1.41537 6.83737 2.03347 6.83737 2.79312V3.1385C6.83737 3.52917 6.5203 3.84624 6.12962 3.84624C5.73895 3.84624 5.42188 3.52917 5.42188 3.1385V2.79312C5.42188 1.25306 6.67506 -0.00012207 8.21511 -0.00012207H10.6498C12.1898 -0.00012207 13.443 1.25306 13.443 2.79312V3.1385C13.443 3.52917 13.1259 3.84624 12.7353 3.84624"
            fill={color}
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9061 18.6279H3.95958C2.00148 18.6279 0.352904 17.0982 0.204749 15.1449L0.0254537 12.7772C-0.00379985 12.3875 0.288735 12.0468 0.678468 12.0176C1.07009 12.0034 1.40792 12.2799 1.43812 12.6706L1.61647 15.0373C1.70895 16.2565 2.73754 17.2124 3.95958 17.2124H14.9061C16.1281 17.2124 17.1576 16.2565 17.2492 15.0373L17.4285 12.6706C17.4587 12.2799 17.805 12.0025 18.1881 12.0176C18.5778 12.0468 18.8694 12.3875 18.8402 12.7772L18.6609 15.1449C18.5127 17.0982 16.8642 18.6279 14.9061 18.6279"
          fill={color}
        />
      </svg>
    );
  }),
);

SuitcaseIcon.displayName = "SuitcaseIcon";